<template>
  <div v-if="items.length || !loaded" class="col-12">
    <div class="col-12 pb-1">
      <template v-if="skeletonLoading">
        <PageReportItem class="event-skeleton mb-1" v-for="idx in 9" :key="'skeleton-row_' + idx">
          <td class="typo-regular text-light-low col-8 align-items-start">
            <p class="skeleton skeleton-light w220 h14 event-skeleton__border"></p>
            <p class="skeleton skeleton-light w402 h14 mt-1 event-skeleton__border"></p>
          </td>
          <td class="typo-regular text-light-low col-2 align-items-start justify-content-end event-skeleton__left">
            <p class="skeleton skeleton-light w125 h14 ml-2 event-skeleton__border"></p>
          </td>
          <td class="typo-regular text-light-low col-2 align-items-end event-skeleton__right">
            <p class="skeleton skeleton-light w125 h14 mr-2 event-skeleton__border"></p>
            <p class="skeleton skeleton-light w100 h14 mr-2 mt-1 event-skeleton__border"></p>
          </td>
        </PageReportItem>
      </template>
      <template v-else>
        <EventListItem v-for="item in items" :key="item.id" :item="item">
        </EventListItem>
      </template>
    </div>
  </div>
  <div v-else class="d-flex mt56 flex-column align-items-center col-12">
    <img :src="require('@/core/assets/event-empty-result.png')">
    <p v-if="noActivities" class="text-center typo-heading16 typo-semi-150 mt-2 noresult">{{ $t(`storeSettings.eventLogs.noactivities`) }}</p>
    <p v-else class="text-center typo-heading16 typo-semi-150 mt-2 noresult">{{ $t(`storeSettings.eventLogs.noresult`) }}</p>
  </div>
</template>

<script>
import EventListItem from "./EventListItem";
import PageReportItem from "@/modules/Analytics/components/PageReportItem.vue"

export default {
  components: {EventListItem, PageReportItem},
  props: {
    items: {
      type: Array,
      defaultValue: [],
    },
    skeletonLoading: {
      type: Boolean,
      defaultValue: false,
    },
    loaded: {
      type: Boolean,
      defaultValue: false,
    },
    noActivities: {
      type: Boolean,
      defaultValue: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.mt56 {
  margin-top: 56px;
}

.noresult {
  color: #3C67FF80;
}
</style>
